import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShield2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconShield2"><Path fillRule="evenodd" clipRule="evenodd" d="M10.926 1.89089C11.6124 1.59969 12.3876 1.59969 13.074 1.89089L19.324 4.5424C20.3401 4.97347 21 5.97026 21 7.074V12.9999C21 17.9705 16.9706 21.9999 12 21.9999C7.02944 21.9999 3 17.9705 3 12.9999V7.074C3 5.97026 3.65991 4.97347 4.67599 4.5424L10.926 1.89089Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShield2;
